export default __webpack_public_path__ + "static/5521fad59281758b74dbb29ce13b322a.png";